import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import Layout from './components/layout/Layout';

// Import pages
import Home from './pages/Home';
import Solutions from './pages/Solutions';
import Omnichannel from './pages/solutions/Omnichannel';
import Products from './pages/Products';
import PIM from './pages/products/PIM';
import DAM from './pages/products/DAM';
import MDM from './pages/products/MDM';
import CDP from './pages/products/CDP';
import Pricing from './pages/Pricing';
import Partners from './pages/Partners';
import Resources from './pages/Resources';
import NotFound from './pages/NotFound';

// Import i18n
import './i18n/i18n';
import Contact from './pages/Contact';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Helmet>
        <title>IMEETTECH - 连接技术与全球市场的桥梁</title>
        <meta name="description" content="IMEETTECH是一家专注于提供软件服务与企业级新市场开拓解决方案的技术公司，致力于帮助企业实现数字化转型和全球市场扩张。" />
        {/* <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Roboto:wght@300;400;500;700&family=Noto+Sans+SC:wght@300;400;500;700&display=swap" rel="stylesheet" /> */}
      </Helmet>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/omnichannel" element={<Omnichannel />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/pim" element={<PIM />} />
            <Route path="/products/dam" element={<DAM />} />
            <Route path="/products/mdm" element={<MDM />} />
            <Route path="/products/cdp" element={<CDP />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;